$(document).ready(function () {
  function setCookie(name, value, exdays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    let c_value = escape(value) + ((exdays == null) ? "" : ";path=/; expires=" + exdate.toUTCString());
    document.cookie = name + "=" + c_value;
  }

  function getCookie(name) {
    let i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
      x = x.replace(/^\s+|\s+$/g, "");
      if (x === name) {
        return unescape(y);
      }
    }
  }

  let checkAcceptCookie = getCookie('newsletter') === '1';

  if(checkAcceptCookie) {
    $('body').css('overflow', 'visible');
    $('.subscribe-section-overlay').css({"display":"none"});
  } else {
    setTimeout(function() {
      // $('body').css('overflow', 'hidden');
      // $('.subscribe-section-overlay').css({"display":"block"});

    }, 10000)

  }

  $(window).on('klaviyoForms', function(e){
    if(e.originalEvent.detail.type === 'submit') {
      setCookie('newsletter', '1', 30);
      setTimeout(function() {
        $('.subscribe-section-overlay').addClass('hide');

        $("body").css({"overflow":"visible"});

      }, 1500)
    }
  })
});